import React, { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  TextField,
  Button,
  IconButton,
  InputAdornment,
  Tooltip,
  Chip,
  CircularProgress,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Grid
} from "@mui/material";
import {
  Edit as EditIcon,
  Search as SearchIcon,
  WarningAmber as WarningIcon,
  CheckCircle as CheckIcon,
} from "@mui/icons-material";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz'; // icon for transfer
import * as XLSX from "xlsx";

import axios from "axios";
import baseURL from "../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import TransferVesselBeforeSignOnModal from "./TransferVesselBeforeSignOnModal";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TablePagination from "@mui/material/TablePagination";
import { jwtDecode } from "jwt-decode";

const COCmodal = ({ cocDetails }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCrewName, setSelectedCrewName] = useState("");
  const [selectedIndosNumber, setSelectIndosNumber] = useState("");
  const [selectedVesselName, setSelectVesselName] = useState("");
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [editingCOCId, setEditingCOCId] = useState(null);
  const [newCOCDate, setNewCOCDate] = useState("");


  const userID = localStorage.getItem("user id");

  const [openModal, setOpenModal] = useState(false);
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [formData, setFormData] = useState({
    portName: "",
    portCountry: "",
    date: "",
    contractId: "",
    ImoCrewListFile: null,
    cdcStamppageFile: null,
  });

  const months = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

  const getRemainingDays = (dateStr) => {
    if (!dateStr) return null;
    const cocDate = new Date(dateStr);
    const today = new Date();
    const diffTime = today - cocDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const remaining = 30 - diffDays;
    return remaining > 0 ? remaining : 0;
  };

  const getContractRemainingDays = (startDateStr, durationInMonths) => {
    if (!startDateStr || !durationInMonths) return null;

    const startDate = new Date(startDateStr);
    const endDate = new Date(startDate);
    endDate.setMonth(endDate.getMonth() + parseInt(durationInMonths));

    const today = new Date();

    if (endDate <= today) return "Contract Ended";

    let remainingMonths = (endDate.getFullYear() - today.getFullYear()) * 12 +
      (endDate.getMonth() - today.getMonth());

    let adjustedEnd = new Date(today);
    adjustedEnd.setMonth(adjustedEnd.getMonth() + remainingMonths);

    // If adjustedEnd goes past the actual endDate, reduce a month
    if (adjustedEnd > endDate) {
      remainingMonths--;
      adjustedEnd.setMonth(adjustedEnd.getMonth() - 1);
    }

    // Now calculate the remaining days
    const remainingDays = Math.ceil((endDate - adjustedEnd) / (1000 * 60 * 60 * 24));

    const months = remainingMonths;
    const days = remainingDays;

    let result = [];
    if (months) result.push(`${months} month${months > 1 ? "s" : ""}`);
    if (days) result.push(`${days} day${days > 1 ? "s" : ""}`);

    return `Contract remaining : ${result.join(" ")} `;
  };

  const handleTransfer = (contractId) => {
    setSelectedContractId(contractId);
    setOpenModal(true);
  };


  const handleOpen = (contractId, crewName, indosno, vesselname) => {
    setFormData({
      portName: "",
      portCountry: "",
      date: "",
      contractId,
      ImoCrewListFile: null,
      cdcStamppageFile: null,
    });
    setSelectedCrewName(crewName);
    setSelectIndosNumber(indosno);
    setSelectVesselName(vesselname);
    setOpen(true);
  };

  const handleClose = () => {
    if (!loading) {
      setOpen(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChange = (e) =>
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setFormData((prev) => ({
        ...prev,
        [name]: files[0],
      }));
    }
  };

  const handleSave = async () => {
    const { portName, portCountry, date, contractId, cdcStamppageFile, ImoCrewListFile } = formData;

    if (!portName || !portCountry || !date || !cdcStamppageFile || !ImoCrewListFile) {
      toast.error("All fields are required.");
      return;
    }

    // ✅ Validation: Sign-On Date must not be before COC Date
    const cocDateRaw = cocDetails.find(item => item.contractDetails?._id === contractId)
      ?.contractStatusAfterForm1?.coc?.[0]?.Date ||
      cocDetails.find(item => item.contractDetails?._id === contractId)
        ?.contractStatusAfterForm1?.coc?.[0]?.date;

    if (cocDateRaw) {
      const cocDate = new Date(cocDateRaw);
      const signOnDate = new Date(date);

      if (signOnDate < cocDate) {
        toast.error("Sign-On Date cannot be earlier than COC Date.");
        return;
      }
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const form = new FormData();

      const signOnData = [
        { portName, portCountry, date },
      ];

      form.append("contractId", contractId);
      form.append("signOn", JSON.stringify(signOnData));
      form.append("signOn[0][cdcStamppageFile]", cdcStamppageFile);
      form.append("signOn[0][ImoCrewListFile]", ImoCrewListFile);
      form.append("creatorId", userID);

      await axios.post(`${baseURL}/api/statusAfterForm1`, form, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("Data saved successfully, Please visit the sign-on page for further action.");
      handleClose();

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Error saving data:", error.message);
      toast.error("Failed to save data.", error.message);
    } finally {
      setLoading(false);
    }
  };
  const filteredCOCDetails = Array.isArray(cocDetails)
    ? cocDetails.filter((item) => {
      const vesselName = item.contractDetails?.ShipDetails?.vesselname?.toLowerCase() || "";
      const crewName = item.contractDetails?.crewdetails?.name?.toLowerCase() || "";
      const indos = item.contractDetails?.crewdetails?.indosno?.toLowerCase() || "";
      return (
        vesselName.includes(searchQuery.toLowerCase()) ||
        crewName.includes(searchQuery.toLowerCase()) ||
        indos.includes(searchQuery.toLowerCase())
      );
    })
    : [];

  // Then filter by date/month/year
  const filteredCocData = filteredCOCDetails.filter((row) => {
    // Get COC Date for month/year filtering
    const cocDateRaw = row.contractStatusAfterForm1?.coc?.[0]?.Date || row.contractStatusAfterForm1?.coc?.[0]?.date;

    // Get Added COC Date for date filtering
    const addedCocDateRaw = row.contractStatusAfterForm1?.coc?.[0]?.creatorIdWithName?.[0]?.createdAt;

    // If no date filters are selected, include all rows
    if (!selectedMonth && !selectedYear && !selectedDate) {
      return true;
    }

    // If specific date filter is selected, use Added COC Date
    if (selectedDate) {
      if (!addedCocDateRaw) return false;
      const addedCocDate = new Date(addedCocDateRaw);
      const dateOnly = addedCocDate.toISOString().split("T")[0];
      return dateOnly === selectedDate;
    }

    // For month/year filters, use COC Date
    if (selectedMonth || selectedYear) {
      if (!cocDateRaw) return false;
      const cocDate = new Date(cocDateRaw);
      const month = String(cocDate.getMonth() + 1).padStart(2, '0');
      const year = String(cocDate.getFullYear());

      const monthMatch = !selectedMonth || month === selectedMonth;
      const yearMatch = !selectedYear || year === String(selectedYear);

      return monthMatch && yearMatch;
    }

    return true;
  });


  const handleExportToExcel = () => {
    const dataToExport = filteredCocData.map((item, index) => {
      const cocDate = item.contractStatusAfterForm1?.coc?.[0]?.Date || item.contractStatusAfterForm1?.coc?.[0]?.date;
      const formattedDate = cocDate ? new Date(cocDate).toLocaleDateString("en-GB") : "N/A";
      const duration = item.contractDetails?.contractDuration;
      const contractRemaining = getContractRemainingDays(cocDate, duration);

      return {
        "Sr No.": index + 1,
        "Vessel Name": item.contractDetails?.ShipDetails?.vesselname || "N/A",
        "Company": item.contractDetails?.vesselOwner?.company_shortname || "N/A",
        "Crew Name": item.contractDetails?.crewdetails?.name || "N/A",
        "Indos No.": item.contractDetails?.crewdetails?.indosno || "N/A",
        "Agent": item.contractDetails?.crewingAgent?.agentName || "N/A",
        "COC Date": formattedDate,
        "Remaining SignOn Days": getRemainingDays(cocDate),
        "Contract Remaining": contractRemaining,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "COC Details");

    XLSX.writeFile(workbook, "COC_Details.xlsx");
  };

  const token = localStorage.getItem("token");
  let userEmail = "";

  if (token) {
    try {
      const decoded = jwtDecode(token);
      userEmail = decoded.email;
    } catch (error) {
      console.error("Invalid token:", error);
    }
  }

  const ChangeCOCDate = async (id) => {
    try {

      if (!newCOCDate) {
        alert("Please select a COC date!");
        return;
      }

      const response = await axios.put(
        `${baseURL}/api/updateCOCDateByEmail/${id}`,
        { newDate: newCOCDate },
        { headers: { Authorization: `Bearer ${token}` } }
      );


      if (response.data.success) {
        alert("✅ COC Date updated successfully!");
        setEditingCOCId(null);
        setNewCOCDate("");
        window.location.reload();

      } else {
        console.warn("⚠️ API returned success:false");
        alert("⚠️ Failed to update COC Date.");
      }
    } catch (error) {
      console.error("❌ Error updating COC Date:", error);
      console.error("❌ Error details:", error.response?.data);
      alert(error.response?.data?.message || "Internal server error");
    }
  };





  return (
    <Box mt={3} width="100%" p={2}>
      {/* Header */}
      <Box
        sx={{
          p: 2,
          bgcolor: "primary.main",
          color: "white",
          display: "flex",
          alignItems: "center",  // vertically center items
          justifyContent: "space-between",
          flexWrap: "nowrap",    // prevent wrapping
          gap: 0,                // remove gaps
        }}
      >
        {/* Search Bar */}
        <TextField
          placeholder="Search by Vessel or Crew Name"
          variant="outlined"
          size="small"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="primary" />
              </InputAdornment>
            ),
          }}
          sx={{
            bgcolor: "#f5f5f5",
            borderRadius: 2,
            width: 280,
            mr: 1, // small margin right to separate from next item slightly if needed
          }}
        />

        {/* Title */}
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={{
            textAlign: "center",
            whiteSpace: "nowrap",
            mr: 2,
          }}
        >
          COC Details
        </Typography>

        {/* Filters: Month and Year */}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Grid container spacing={1} alignItems="center" sx={{ width: "auto" }}>
            {/* Month Selector */}
            <Grid item>
              <FormControl size="small" sx={{ bgcolor: "white", borderRadius: 1, width: 120 }}>
                <InputLabel>Month</InputLabel>
                <Select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  label="Month"
                >
                  <MenuItem value="">All Months</MenuItem>
                  {months.map((m) => (
                    <MenuItem key={m.value} value={m.value}>
                      {m.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Year Selector */}
            <Grid item>
              <FormControl size="small" sx={{ bgcolor: "white", borderRadius: 1, width: 200 }}>
                <InputLabel>Year</InputLabel>
                <Select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  label="Year"
                >
                  <MenuItem value="">All Years</MenuItem>
                  {years.map((year) => (
                    <MenuItem key={year} value={year}>
                      {year}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                size="small"
                type="date"
                label="Filter by Added COC Date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  bgcolor: "white",
                  color: '#c62828',
                  borderRadius: 1,
                  minWidth: 200,
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: 'white',
                  }
                }}
              />

              <Button
                onClick={() => {
                  setSelectedMonth('');
                  setSelectedYear('');
                  setSelectedDate('');
                }}
                variant="outlined"
                size="small"
                sx={{
                  color: 'white',
                  borderColor: 'white',
                  '&:hover': {
                    borderColor: 'white',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}
              >
                Clear Filters
              </Button>
            </Grid>

            {/* Export Button */}
            <Grid item>
              <Button
                onClick={handleExportToExcel}
                variant="contained"
                sx={{
                  width: 180,
                  height: 40,
                  backgroundColor: '#2e7d32',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#1b5e20',
                  },
                }}
              >
                Export to Excel
              </Button>
            </Grid>
          </Grid>
        </Box>


        {/* Total Count */}
        <Typography
          variant="h6"
          fontWeight="500"
          sx={{
            color: "white",
            whiteSpace: "nowrap",
            ml: 2,
          }}
        >
          Total Count: {filteredCocData.length}
        </Typography>
      </Box>



      {/* Table */}
      <Paper elevation={3} sx={{ p: 2 }}>
        {filteredCocData.length > 0 ? (
          <Table stickyHeader>
            <TableHead>
              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: "bold", width: "100px" }}>Sr. No.</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Contract Details</TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "250px" }}>Transfer Details</TableCell>
                <TableCell sx={{ fontWeight: "bold" }} align="center">
                  Action
                </TableCell>

              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCocData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => {
                  const cocDate = item.contractStatusAfterForm1?.coc?.[0]?.Date || item.contractStatusAfterForm1?.coc?.[0]?.date;
                  const remainingDays = getRemainingDays(cocDate);
                  const duration = item.contractDetails?.contractDuration;
                  const contractRemainingLabel = getContractRemainingDays(cocDate, duration);
                  const secondCocDate = item?.contractStatusAfterForm1?.coc?.[1]?.Date;

                  return (
                    <TableRow key={index} hover>
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                          <Typography variant="subtitle2" fontWeight="bold">
                            <strong style={{ color: "black" }}>
                              Vessel Name: {item.contractDetails?.ShipDetails?.vesselname || "N/A"}
                            </strong>
                          </Typography>
                          <Typography variant="subtitle2" fontWeight="bold">
                            <strong style={{ color: "#2e7d32" }}>
                              Company Name: {item.contractDetails?.vesselOwner?.company_shortname || "N/A"}
                            </strong>
                          </Typography>
                        </Box>
                        {console.log("coc", item)}
                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                          <Chip size="small" label={`Crew: ${item.contractDetails?.crewdetails?.name || "N/A"}`} sx={{ bgcolor: "#e3f2fd", color: "#0d47a1" }} />
                          <Chip size="small" label={`Indos No.: ${item.contractDetails?.crewdetails?.indosno || "N/A"}`} sx={{ bgcolor: "#fff9c4", color: "#f57f17" }} />
                          <Chip size="small" label={`Agent: ${item.contractDetails?.crewingAgent?.agentName || "N/A"}`} sx={{ bgcolor: "#f3e5f5", color: "#6a1b9a" }} />
                          {/* <Chip
                            size="small"
                            label={`COC Date: ${cocDate ? new Date(cocDate).toLocaleDateString("en-GB") : "N/A"}`}
                            sx={{ bgcolor: "#fff3e0", color: "#e65100", fontWeight: 'bold' }}
                          /> */}
                          {/* ✅ Show editable or view mode for COC Date */}
                          {editingCOCId === item?.contractStatusAfterForm1?._id &&
                            userEmail === "neeturashmi@gmail.com" ? (
                            <>
                              <TextField
                                type="date"
                                value={newCOCDate}
                                onChange={(e) => setNewCOCDate(e.target.value)}
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                sx={{ mr: 1 }}
                              />
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => ChangeCOCDate(item?.contractStatusAfterForm1?._id)}
                                disabled={!newCOCDate}
                              >
                                Save
                              </Button>
                              <Button
                                variant="outlined"
                                size="small"
                                sx={{ ml: 1 }}
                                onClick={() => {
                                  setEditingCOCId(null);
                                  setNewCOCDate("");
                                }}
                              >
                                Cancel
                              </Button>
                            </>
                          ) : (
                            <>
                              {/* <Chip
                                size="small"
                                label={`COC Date: ${cocDate ? new Date(cocDate).toLocaleDateString("en-GB") : "N/A"}`}
                                sx={{ bgcolor: "#fff3e0", color: "#e65100", fontWeight: 'bold' }}
                              /> */}
                              <Chip
                                size="small"
                                label={`COC Date: ${item?.contractStatusAfterForm1?.coc?.[0]?.Date
                                  ? new Date(item?.contractStatusAfterForm1.coc[0].Date)
                                    .toLocaleDateString("en-GB", {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    })
                                  : "N/A"
                                  }`}
                                sx={{ bgcolor: "#fff3e0", color: "#e65100" }}
                              />
                              {userEmail === "neeturashmi@gmail.com" && (
                                <Tooltip title="Edit COC Date">
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => {
                                      setEditingCOCId(item?.contractStatusAfterForm1?._id);
                                      setNewCOCDate(
                                        item?.contractStatusAfterForm1?.coc?.[0]?.date
                                          ? new Date(item.contractStatusAfterForm1.coc[0].date)
                                            .toISOString()
                                            .split("T")[0]
                                          : ""
                                      );
                                    }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                            </>
                          )}


                          {remainingDays !== null && (
                            <Chip
                              size="medium"
                              icon={
                                remainingDays === 0 ? (
                                  <WarningIcon sx={{ color: "#b71c1c" }} />
                                ) : (
                                  <HourglassEmptyIcon sx={{ color: "#1b5e20" }} />
                                )
                              }
                              label={
                                remainingDays === 0
                                  ? "COC Expired"
                                  : `SignOn Remaining: ${remainingDays} day${remainingDays > 1 ? "s" : ""}`
                              }
                              sx={{
                                bgcolor: remainingDays === 0 ? "#ffebee" : "#ede7f6",
                                color: remainingDays === 0 ? "#b71c1c" : "#311b92",
                                fontWeight: "bold",
                                borderRadius: 2,
                                px: 2,
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                userSelect: "none",
                                minWidth: 130,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            />
                          )}
                          {contractRemainingLabel && (
                            <Chip
                              size="medium"
                              icon={
                                contractRemainingLabel === "Contract Ended" ? (
                                  <WarningIcon sx={{ color: "#b71c1c" }} />
                                ) : (
                                  <HourglassEmptyIcon sx={{ color: "#0277bd" }} />
                                )
                              }
                              label={contractRemainingLabel}
                              sx={{
                                bgcolor: contractRemainingLabel === "Contract Ended" ? "#ffebee" : "#e1f5fe",
                                color: contractRemainingLabel === "Contract Ended" ? "#b71c1c" : "#01579b",
                                fontWeight: "bold",
                                borderRadius: 2,
                                px: 2,
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                userSelect: "none",
                                minWidth: 180,
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            />
                          )}

                          {/* {item?.contractStatusAfterForm1?.coc?.[0]?.creatorIdWithName?.[0] && (
                            <Chip
                              size="small"
                              label={`Added COC: ${item.contractStatusAfterForm1.coc[0].creatorIdWithName[0].name} - ${new Date(item.contractStatusAfterForm1.coc[0].creatorIdWithName[0].createdAt).toLocaleDateString('en-GB')}`}
                              sx={{ bgcolor: "#ffebee", color: "#c62828" }}
                            />
                          )} */}
                          {item?.contractStatusAfterForm1?.coc?.[0]?.creatorIdWithName?.length > 0 && (
                            <Chip
                              size="small"
                              label={`Added COC: ${item.contractStatusAfterForm1.coc[0].creatorIdWithName[
                                item.contractStatusAfterForm1.coc[0].creatorIdWithName.length - 1
                              ].name
                                } - ${new Date(
                                  item.contractStatusAfterForm1.coc[0].creatorIdWithName[
                                    item.contractStatusAfterForm1.coc[0].creatorIdWithName.length - 1
                                  ].createdAt
                                )
                                  .toLocaleDateString("en-GB")
                                  .replace(/\//g, "-")}`}
                              sx={{ bgcolor: "#ffebee", color: "#c62828" }}
                            />
                          )}



                        </Box>
                      </TableCell>
                      <TableCell>
                        {item.contractDetails?.transferedVesselName && (
                          <Typography variant="subtitle2" fontWeight="bold">
                            <strong style={{ color: "black" }}>Vessel Name:</strong>{" "}
                            {item.contractDetails.transferedVesselName}
                          </Typography>
                        )}

                        {secondCocDate && (
                          <Typography variant="body2" fontWeight="bold" style={{ color: "black" }}>
                            <strong>COC Date:</strong>&nbsp;
                            {new Date(secondCocDate).toLocaleDateString()}
                          </Typography>
                        )}


                        {item?.contractStatus?.Form1FOrRejectedCoc?.originalName && (
                          <Typography variant="body2" fontWeight="bold" display="flex" alignItems="center" gap={1}>
                            Form I:
                            <Tooltip title="View PDF" arrow>
                              <a
                                href={`${baseURL}/Documents/vesselupload/${item.contractStatus.Form1FOrRejectedCoc.fileName}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <PictureAsPdfIcon style={{ color: 'red', cursor: 'pointer' }} />
                              </a>
                            </Tooltip>
                          </Typography>
                        )}


                      </TableCell>
                      <TableCell align="center">
                        <Tooltip title="Add Signon">
                          <IconButton
                            onClick={() =>
                              handleOpen(
                                item.contractDetails?._id || "",
                                item.contractDetails?.crewdetails?.name || "N/A",
                                item.contractDetails?.crewdetails?.indosno || "N/A",
                                item.contractDetails?.ShipDetails?.vesselname || "N/A"
                              )
                            }
                            color="primary"
                          >
                            <EditIcon />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Transfer Vessel">
                          <IconButton
                            onClick={() => handleTransfer(item.contractDetails?._id)}
                            color="secondary"
                          >
                            <SwapHorizIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        ) : (
          <Typography color="textSecondary" align="center" sx={{ mt: 2 }}>
            No matching COC details found.
          </Typography>
        )}
      </Paper>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 450,
            p: 4,
            borderRadius: 3,
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" align="center" gutterBottom>
            Enter Sign-On: {" "}
            {selectedCrewName && selectedIndosNumber && selectedVesselName && (
              <span style={{ color: "green" }}>
                {`${selectedCrewName} - ${selectedIndosNumber} - ${selectedVesselName}`}
              </span>
            )}
          </Typography>

          {/* <TextField
            fullWidth
            label="INDOS Number"
            value={selectedIndosNumber || ""}
            margin="normal"
            variant="outlined"
            disabled
          /> */}

          <TextField
            required
            fullWidth
            label="Port Name"
            name="portName"
            value={formData.portName}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />

          <TextField
            required
            fullWidth
            label="Port Country"
            name="portCountry"
            value={formData.portCountry}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />

          <TextField
            required
            fullWidth
            label="Date"
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            inputProps={{ max: new Date().toISOString().split("T")[0] }}
          />

          <Box mt={2}>
            <Typography variant="body2" gutterBottom>
              CDC Stamp Page File *
            </Typography>
            <label htmlFor="cdc-upload">
              <input
                accept="application/pdf,image/*"
                style={{ display: "none" }}
                id="cdc-upload"
                type="file"
                name="cdcStamppageFile"
                onChange={handleFileChange}
              />
              <Button variant="outlined" component="span" fullWidth>
                {formData.cdcStamppageFile?.name || "Upload File"}
              </Button>
            </label>
          </Box>

          <Box mt={2}>
            <Typography variant="body2" gutterBottom>
              IMO Crew List File *
            </Typography>
            <label htmlFor="imo-upload">
              <input
                accept="application/pdf,image/*"
                style={{ display: "none" }}
                id="imo-upload"
                type="file"
                name="ImoCrewListFile"
                onChange={handleFileChange}
              />
              <Button variant="outlined" component="span" fullWidth>
                {formData.ImoCrewListFile?.name || "Upload File"}
              </Button>
            </label>
          </Box>

          <Box mt={3} display="flex" justifyContent="space-between">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} color="inherit" />}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
          </Box>
        </Paper>
      </Modal>

      <TransferVesselBeforeSignOnModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        contractId={selectedContractId}
      />

      <TablePagination
        component="div"
        count={filteredCocData.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 25, 50]}
        sx={{
          px: 2,
          bgcolor: "#fafafa",
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          justifyContent: "flex-end"
        }}
      />

      <ToastContainer />
    </Box>
  );
};

export default COCmodal;
